import { useEffect } from "react";

import { useGetSdlConfig } from "../../../components/hooks";
import { filterData } from "../../../services";
import { dataMappingFargFilters } from "../../../services/dataMappingForFilters";
import { Box } from "../../cores";
import {
  useComparePreviusValuesWithCurrent,
  useUpdateRowFargData,
} from "../../hooks";
import FilterDescription from "../../molecules/FilterDescription";
import { sortTable } from "../../molecules/Table/SortTable";
import {
  ContentDescriptionContainer,
  FilterCollection,
  TableWithPages,
} from "../../organisms";
import { useTableContext } from "../../providers";
import { IKeyStringAndValue, IOptions } from "../../types/Types";

export default function FargView() {
  const data = useUpdateRowFargData();
  const { listView } = useTableContext();
  const sdlConfig = useGetSdlConfig(listView).data as Array<IOptions>;
  const {
    filteredData,
    setFilteredData,
    filterOptions,
    setSortedField,
    arrowState,
    setArrowState,
    setCurrentPage,
    selectedData,
    isCompare,
    setInputValue,
  } = useTableContext();
  const { filteredDataSnapshot } = useComparePreviusValuesWithCurrent(
    filteredData,
    filterOptions,
    setInputValue
  );

  const findSortingValue = sdlConfig.findIndex((element: IOptions) => {
    return (filterOptions as IKeyStringAndValue)["omrade"] === "Alnarp (Malmö)"
      ? element.key === "alnarp_betyg"
      : (filterOptions as IKeyStringAndValue)["omrade"] === "Uppsala"
      ? element.key === "uppsala_betyg"
      : (filterOptions as IKeyStringAndValue)["omrade"] === "Vindeln (Umeå)"
      ? element.key === "vindeln_betyg"
      : (filterOptions as IKeyStringAndValue)["omrade"] === "Boras"
      ? element.key === "boras_betyg"
      : element.key === "riksbetyg";
  });
  useEffect(() => {
    sortTable(
      sdlConfig[findSortingValue].key,
      filterData(isCompare ? selectedData : data, sdlConfig, filterOptions),
      setFilteredData,
      arrowState ? !!arrowState : !arrowState,
      setCurrentPage
    );
    setArrowState(
      !arrowState
        ? (prevArrowState) => !!prevArrowState
        : (prevArrowState) => !prevArrowState
    );
    setSortedField(sdlConfig[findSortingValue].key);
    setCurrentPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, filterOptions, isCompare, selectedData]);
  return (
    <Box sx={{ maxWidth: "1240px", margin: "auto", paddingTop: 20 }}>
      <FilterCollection
        filteredCategories={
          dataMappingFargFilters({ filteredData: filteredDataSnapshot })
            .categories
        }
        allCategories={
          dataMappingFargFilters({ filteredData: data }).categories
        }
      />
      <FilterDescription filterOptions={filterOptions} />
      <ContentDescriptionContainer columns={sdlConfig} />
      <TableWithPages data={data} />
    </Box>
  );
}
